const { isEmpty } = require('lodash');

const fields = () => {
  return {
    date: {
      label: '日付',
      type: 'date',
      validations: {
        required: (_) => _ != null,
      },
    },
    amount: {
      label: '金額',
      type: 'integer',
      validations: {
        required: (_) => _ != null,
      },
    },
    description: {
      label: '説明',
      type: 'string',
      validations: {
        required: (_) => _ != null,
      },
    },
  };
};

module.exports = {
  fields,
};
